<!-- @veltra/icons generated sha256:8e4737550e4571ce gen:8 source:src/svg/normal/lock.svg -->
<script setup lang="ts">
defineOptions({ name: 'Lock' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M4.5 6V4.99a3.5 3.5 0 1 1 7 0V6H13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-7A.5.5 0 0 1 3 6zm1-1.01V6h5V4.99a2.5 2.5 0 0 0-5 0m7 8.01V7h-9v6zm-6-2a.5.5 0 0 1-.5-.496c0-.276.225-.504.5-.504h3c.275 0 .5.228.5.496a.504.504 0 0 1-.5.504z"
    />
  </svg>
</template>
